/* eslint-disable */
import { getParties, getRegisteredParties, getPendingAssociation, partyDetails, generateCode, getCode, approveSection} from "@/api/parties";
import store from "@/store";

export const getPartyList = (commit, payload) => {
  return new Promise((resolve) => {
    getParties().then((response) => {
      if (response.status_code === 200) {
        store.commit("parties/setParties", response.data);
      }
      resolve();
    });
  });
};

export const getPartyRegisteredList = (commit, payload) => {
  return new Promise((resolve) => {
    getRegisteredParties().then((response) => {
      if (response.status_code === 200) {
        store.commit("parties/setParties", response.data);
      }
      resolve();
    });
  });
};

export const getPendingAssociationList = (commit, payload) => {
  return new Promise((resolve) => {
    getPendingAssociation().then((response) => {
      if (response.status_code === 200) {
        store.commit("parties/setAssociations", response.data);
      }
      resolve();
    });
  });
};

export const getPartyDetails = (commit, payload) => {
  store.commit("parties/setParty", []);
  return new Promise((resolve) => {
    partyDetails(payload).then((response) => {
      if (response.status_code === 200) {
        store.commit("parties/setParty", response.data);
      }
      resolve();
    });
  });
};

export const generateApplicationCode = (commit, payload) => {
  return new Promise((resolve) => {
    generateCode(payload).then((response) => {      
      // if (response.status_code === 201) {
      //   getPartyDetails(commit, {partyID: payload.party_id})
      // }
      resolve(response);
    });
  });
};

export const getAccessCode = (commit, payload) => {
  return new Promise((resolve) => {
    getCode(payload).then((response) => {    
      resolve(response);
    });
  });
};

export const approveApplicationSection = (commit, payload) => {
  return new Promise((resolve) => {
    approveSection(payload).then((response) => {   
      if (response.status_code === 200) {
        store.commit("parties/setParty", response.data);
      } 
      resolve(response);
    });
  });
};
